const hasValidPaymentMethod = (company) => {
  return !!company.stripePaymentMethodId;
};

export default hasValidPaymentMethod;
